module.exports = __webpack_public_path__ + "assets/LDropPerp.cf3e55a21303a7fd6fce3187b749d369.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/LDropPerp.gmt
// module id = 963
// module chunks = 0